export default {
  'components.cleanTextContextMenu.copy': 'संदर्भों के बिना टेक्स्ट कॉपी करें',
  'components.cleanTextContextMenu.copied': 'टेक्स्ट कॉपी किया गया',
  'components.cleanTextContextMenu.failed': 'टेक्स्ट कॉपी नहीं हो सका। कृपया फिर से कोशिश करें।',
  'components.addToMattersPopover.selectMattersLabel': 'मैटर चुनें:',
  'components.addToMattersPopover.searchPlaceholder': 'मैटर खोजें...',
  'components.addToMattersPopover.updateSuccess': 'मैटर सफलतापूर्वक अपडेट हुए',
  'components.addToMattersPopover.updateError': 'मैटर अपडेट करने में विफल',
  'components.billingRequiredOverlay.defaultMessage':
    'यह कार्रवाई जारी रखने से पहले आपके संगठन की बिलिंग पर ध्यान देना आवश्यक है। कृपया अपने संगठन के एडमिन से संपर्क करें।',
  'components.billingRequiredOverlay.title': 'बिलिंग आवश्यक',
  'components.billingRequiredOverlay.manageBillingButton': 'बिलिंग प्रबंधित करें',
  'components.chat.jsonResponseTitle': 'JSON प्रतिक्रिया',
  'components.chat.dataOpenedInNewTab': 'डेटा नए टैब में खोला गया',
  'components.chat.textResponseTitle': 'टेक्स्ट प्रतिक्रिया',
  'components.chat.contentOpenedInNewTab': 'सामग्री नए टैब में खोली गई',
  'components.chat.fileOpenedInNewTab': 'फ़ाइल नए टैब में खोली गई',
  'components.chat.failedToOpenNewTab': 'नया टैब खोलने में विफल',
  'components.chat.failedToFetchUrl': 'URL लाने में विफल: {message}',
  'components.chat.referenceDocumentFallback': 'संदर्भ दस्तावेज़',
  'components.chat.sourcesCount': 'स्रोत ({count})',
  'components.chat.referencesCount': '{count} संदर्भ',
  'components.chat.htmlContentTitle': 'HTML सामग्री',
  'components.chat.showMoreLines': 'और दिखाएँ ({count} पंक्तियाँ)',
  'components.chatWidget.waitingMessage.justAMoment': 'बस एक क्षण...',
  'components.chatWidget.waitingMessage.fetchingThatForYou': 'आपके लिए वह लाया जा रहा है...',
  'components.chatWidget.waitingMessage.hangTight': 'थोड़ा रुकिए, मैं इस पर काम कर रहा हूँ...',
  'components.chatWidget.waitingMessage.letMeCheck': 'मुझे जाँचने दीजिए...',
  'components.chatWidget.waitingMessage.thisWillJustTakeASecond': 'इसमें बस एक पल लगेगा...',
  'components.chatWidget.closeChatAriaLabel': 'चैट बंद करें',
  'components.chatWidget.openChatAriaLabel': 'चैट खोलें',
  'components.chatWidget.processingTooltip': 'प्रोसेसिंग पूरी होने पर चैट उपलब्ध होगी',
  'components.chatWidget.messageCopied': 'संदेश कॉपी हो गया!',
  'components.chatWidget.copyMessageFailed': 'संदेश कॉपी करने में विफल',
  'components.chatWidget.header.title': 'चैट',
  'components.chatWidget.emptyState.title': 'मैं किस तरह मदद कर सकता हूँ?',
  'components.chatWidget.inputPlaceholder': 'संदेश लिखें...',
  'components.chatWidget.showMoreLines': 'और दिखाएँ ({count} पंक्तियाँ)',
  'components.chatWidget.invalidFileUrl': 'अमान्य या अनुपलब्ध फ़ाइल URL',
  'components.chatWidget.fileDownloadedSuccessfully': 'फ़ाइल सफलतापूर्वक डाउनलोड हुई',
  'components.chatWidget.fileDownloadFailed': 'फ़ाइल डाउनलोड करने में विफल: {message}',
  'components.chatWidget.unnamedFile': 'फ़ाइल',
  'components.chatWidget.attachmentImageAlt': 'अनुलग्नक',
  'components.checklistCard.heading': 'चेकलिस्ट',
  'components.downloadLoadingMask.downloading': 'डाउनलोड हो रहा है...',
  'components.emlViewer.fromLabel': 'प्रेषक:',
  'components.emlViewer.toLabel': 'प्राप्तकर्ता:',
  'components.emlViewer.ccLabel': 'प्रतिलिपि:',
  'components.emlViewer.dateLabel': 'दिनांक:',
  'components.emlViewer.attachmentsLabel': 'अनुलग्नक:',
  'components.filesSidePanel.favoritesButton': 'पसंदीदा',
  'components.filesSidePanel.historyButton': 'इतिहास',
  'components.filesSidePanel.untitledPlaceholder': '(शीर्षकहीन)',
  'components.filesSidePanel.membersPopoverTitle': 'सदस्य',
  'components.filesSidePanel.ownerTag': 'स्वामी',
  'components.filesSidePanel.modifyGroupTooltip': 'समूह संशोधित करें',
  'components.filesSidePanel.privateGroupWarningTooltip': 'कम सुरक्षित: आपके समूह को दिखाई देगा।',
  'components.filesSidePanel.firmWideWarningTooltip':
    'अत्यंत असुरक्षित: आपकी पूरी फ़र्म को दिखाई देगा।',
  'components.filesSidePanel.publicWarningTooltip': 'अत्यंत असुरक्षित: सभी को दिखाई देगा।',
  'components.filesSidePanel.sortByDateLabel': 'दिनांक अनुसार क्रमबद्ध करें (नए से पुराने)',
  'components.filesSidePanel.sortAlphabeticallyLabel': 'वर्णानुक्रम में क्रमबद्ध करें (A-Z)',
  'components.gettingStartedTour.insiderHero.openLinkLabel': 'A&GEL Insider खोलें',
  'components.gettingStartedTour.insiderHero.logoAlt': 'A&GEL Insider',
  'components.gettingStartedTour.insiderHero.heroTitle': 'नए टूल सीखने में समय लगता है',
  'components.gettingStartedTour.insiderHero.basicsCard.copy': 'पहले दिन से आपको जो कुछ भी चाहिए।',
  'components.gettingStartedTour.insiderHero.basicsCard.cta': 'बुनियादी बातों से शुरू करें',
  'components.gettingStartedTour.insiderHero.learnMoreCard.copy':
    'उन लोगों के लिए उन्नत सुविधाएँ जो और आगे जाना चाहते हैं।',
  'components.gettingStartedTour.insiderHero.learnMoreCard.cta': 'और जानें',
  'components.gettingStartedTour.insiderHero.whatsNewCard.copy': 'हाल की रिलीज़ और अपडेट।',
  'components.gettingStartedTour.insiderHero.whatsNewCard.cta': 'नया क्या है',
  'components.gettingStartedTour.insiderHero.marinaAlt': 'मरीना क्षितिज',
  'components.gettingStartedTour.insiderHero.featuredArticleLabel': 'विशेष लेख',
  'components.gettingStartedTour.insiderHero.filesUpload.title': 'Grammar of Use',
  'components.gettingStartedTour.insiderHero.filesUpload.description':
    'हम Grammar of Use नामक निर्देशात्मक सामग्री का एक नया रूप प्रस्तुत कर रहे हैं। पहला संस्करण नए उपयोगकर्ताओं के लिए एक सामान्य मार्गदर्शिका है, जिसमें भरपूर उदाहरण और संबंधित सुविधाओं के लिंक शामिल हैं',
  'components.gettingStartedTour.insiderHero.filesUpload.cta': 'और देखें',
  'components.gettingStartedTour.allCompleted.title': 'आपने पूरा A&GEL टूर पूरा कर लिया!',
  'components.gettingStartedTour.allCompleted.redoButton': 'टूर दोबारा करें',
  'components.gettingStartedTour.heading': 'शुरुआत करें',
  'components.gettingStartedTour.tourStyles.stepIndicator': '{total} में से चरण {current}',
  'components.gettingStartedTour.tourStyles.nextDefault': 'आगे →',
  'components.gettingStartedTour.chatTour.step1.title':
    'हमने आपके लिए एक नमूना NDA लोड किया है। इसे देखने के लिए संदर्भ पर क्लिक करें।',
  'components.gettingStartedTour.chatTour.step1.text':
    'यहाँ आप प्रबंधित करते हैं कि उत्तर देते समय A&GEL किन दस्तावेज़ों का संदर्भ लेता है।',
  'components.gettingStartedTour.chatTour.step2.title': 'यह रहा आपका लोड किया गया दस्तावेज़।',
  'components.gettingStartedTour.chatTour.step2.text':
    'आप फ़ाइलें अपलोड कर सकते हैं या अपने वॉल्ट से चुन सकते हैं। तैयार होने पर पैनल बंद करें।',
  'components.gettingStartedTour.chatTour.step2.nextLabel': 'बंद करें और जारी रखें →',
  'components.gettingStartedTour.chatTour.step3.title':
    'हमने आपके लिए एक प्रश्न तैयार किया है। NDA के बारे में पूछने के लिए भेजें पर क्लिक करें।',
  'components.gettingStartedTour.chatTour.sampleQuestionDisplay':
    'इस अनुबंध में गोपनीयता संबंधी दायित्व क्या हैं?',
  'components.gettingStartedTour.chatTour.step4.title':
    'बढ़िया उत्तर! अब स्रोत दस्तावेज़ देखने के लिए किसी संदर्भ संख्या (जैसे [1]) पर क्लिक करें।',
  'components.gettingStartedTour.chatTour.step4.text':
    'संदर्भ सीधे दस्तावेज़ के उसी हिस्से से जुड़े होते हैं जिसका AI ने उपयोग किया।',
  'components.gettingStartedTour.chatTour.completeModal.title': 'बहुत बढ़िया!',
  'components.gettingStartedTour.chatTour.completeModal.description':
    'आपने चैट में अपना पहला प्रश्न पूछा और स्रोत-सहित उत्तर प्राप्त किया।',
  'components.gettingStartedTour.tourComplete.progressText':
    '5 में से {completedCount} सुविधाएँ पूर्ण',
  'components.gettingStartedTour.tourComplete.completeButton': 'पूर्ण करें',
  'components.gettingStartedTour.tourComplete.continueButton': '{title} पर जारी रखें →',
  'components.gettingStartedTour.playbookTour.completeModal.title': 'शाबाश!',
  'components.gettingStartedTour.playbookTour.completeModal.description':
    'आपने वर्कस्टूडियो से संशोधन लागू किए।',
  'components.gettingStartedTour.playbookTour.step1.title':
    'हमने एक नमूना वेंडर अनुबंध लोड किया है जिसमें संशोधन की आवश्यकता है।',
  'components.gettingStartedTour.playbookTour.step1.text':
    'आप वेंडर (Pand.ai) हैं जो क्लाइंट से अधिक अनुकूल शर्तों का अनुरोध कर रहे हैं।',
  'components.gettingStartedTour.playbookTour.step1.openingLabel': 'खोला जा रहा है…',
  'components.gettingStartedTour.playbookTour.step1.openSampleLabel': 'नमूना खोलें →',
  'components.gettingStartedTour.playbookTour.step2.title': 'हमने 3 संशोधन अनुरोध तैयार किए हैं:',
  'components.gettingStartedTour.playbookTour.step2.item1':
    '• संयुक्त बौद्धिक संपदा स्वामित्व (खंड 17)',
  'components.gettingStartedTour.playbookTour.step2.item2': '• 14-दिन की सुधार अवधि जोड़ें (खंड 8)',
  'components.gettingStartedTour.playbookTour.step2.item3':
    '• गैर-प्रतिस्पर्धा शर्त सीमित करें (खंड 27)',
  'components.gettingStartedTour.playbookTour.step2.text':
    'मल्टी-स्टेप मोड तेज़ परिणामों के लिए प्रत्येक को समानांतर रूप से प्रोसेस करता है।',
  'components.gettingStartedTour.playbookTour.step3.title':
    'संशोधन तैयार करने के लिए भेजें पर क्लिक करें।',
  'components.gettingStartedTour.playbookTour.step3.text':
    'A&GEL ट्रैक किए गए बदलाव दिखाएगा जिन्हें आप स्वीकार, अस्वीकार या डाउनलोड कर सकते हैं।',
  'components.gettingStartedTour.playbookTour.step4.title':
    'ये रहे वे संशोधन जो A&GEL ने आपके प्रॉम्प्ट से तैयार किए।',
  'components.gettingStartedTour.playbookTour.step4.text':
    'प्रत्येक कार्ड मूल पाठ और प्रस्तावित बदलाव दिखाता है।',
  'components.gettingStartedTour.playbookTour.step5.title':
    'इस संशोधन की समीक्षा करें और इसे स्वीकार या अस्वीकार करें।',
  'components.gettingStartedTour.playbookTour.step5.text':
    'आप बाकी के लिए यह बाद में दोहरा सकते हैं।',
  'components.gettingStartedTour.reviewTour.completeModal.title': 'प्रभावशाली!',
  'components.gettingStartedTour.reviewTour.completeModal.description':
    'आपने एक प्रश्न सूची बनाई और उससे दस्तावेज़ों की समीक्षा की।',
  'components.gettingStartedTour.reviewTour.step1.title':
    'समीक्षा, प्रश्न सूचियों का उपयोग करके कई दस्तावेज़ों में आपके प्रश्नों का उत्तर देती है।',
  'components.gettingStartedTour.reviewTour.step1.text':
    'आप अपनी खुद की बना सकते हैं या मौजूदा का उपयोग कर सकते हैं।',
  'components.gettingStartedTour.reviewTour.step2.title':
    'श्रेणी अनुसार पूर्व-निर्मित प्रश्न सूचियाँ ब्राउज़ करें।',
  'components.gettingStartedTour.reviewTour.step3.title':
    'आइए आपकी अपनी सूची बनाएँ। नई प्रश्न सूची शुरू करने के लिए यहाँ क्लिक करें।',
  'components.gettingStartedTour.reviewTour.step4.title':
    'अपनी सूची व्यवस्थित करने के लिए एक श्रेणी चुनें।',
  'components.gettingStartedTour.reviewTour.step5.title':
    'ये कुछ नमूना प्रश्न हैं, जो आपकी सूची में संपादन-योग्य पंक्तियों के रूप में जोड़े गए हैं।',
  'components.gettingStartedTour.reviewTour.step6.title':
    'आपके प्रश्न यहाँ संपादन-योग्य पंक्तियों के रूप में दिखते हैं। आप उन्हें कभी भी हटा सकते हैं या समूहबद्ध करने के लिए अनुभाग जोड़ सकते हैं।',
  'components.gettingStartedTour.reviewTour.step7.title':
    'बताएँ कि यह सूची किस लिए है — इसे अपनी ज़रूरतों के अनुसार ढालें।',
  'components.gettingStartedTour.reviewTour.step8.title':
    'AI कैसे उत्तर देता है, उसे समायोजित करें — लहजा, प्रारूप, विस्तार का स्तर।',
  'components.gettingStartedTour.reviewTour.step9.title':
    'दस्तावेज़ों पर उपयोग करने के लिए अपनी सूची सहेजें।',
  'components.gettingStartedTour.reviewTour.step10.title':
    'हमने आपके प्रयोग के लिए कुछ नमूना दस्तावेज़ लोड किए हैं।',
  'components.gettingStartedTour.reviewTour.step10.text':
    'आपकी प्रश्न सूची उन पर चलाने के लिए तैयार है।',
  'components.gettingStartedTour.reviewTour.step11.title':
    'सभी दस्तावेज़ों पर समीक्षा चलाने के लिए सबमिट दबाएँ।',
  'components.gettingStartedTour.reviewTour.step12.title':
    'प्रत्येक पंक्ति एक प्रश्न है, प्रत्येक कॉलम एक दस्तावेज़। उत्तर स्वतः निकाले जाते हैं।',
  'components.gettingStartedTour.reviewTour.step13.title':
    'यह देखने के लिए कि उत्तर कहाँ से आया, किसी भी उत्तर पर क्लिक करें।',
  'components.gettingStartedTour.reviewTour.step14.title':
    'स्रोत दस्तावेज़ के सटीक अंश पर जाने के लिए संदर्भ संख्या पर क्लिक करें।',
  'components.gettingStartedTour.reviewTour.step15.title':
    'यही है पूरा समीक्षा फ़्लो — स्रोत हमेशा एक क्लिक दूर होते हैं। आपका काम पूरा हुआ!',
  'components.gettingStartedTour.reviewTour.step15.nextLabel': 'समाप्त करें',
  'components.gettingStartedTour.scribeTour.completeModal.title': 'शाबाश!',
  'components.gettingStartedTour.scribeTour.completeModal.description':
    'आपने स्क्राइब से ऑडियो का प्रतिलेखन किया।',
  'components.gettingStartedTour.scribeTour.step1.title':
    'चुनें कि आप प्रतिलेखन का उपयोग किसलिए करेंगे।',
  'components.gettingStartedTour.scribeTour.step1.text':
    'इससे A&GEL को आउटपुट का प्रारूप तय करने में मदद मिलती है। "मीटिंग नोट्स" पहले से चुना हुआ है।',
  'components.gettingStartedTour.scribeTour.step2.title': 'भाषा "स्वतः पहचान" पर सेट है।',
  'components.gettingStartedTour.scribeTour.step2.text':
    'आप वास्तविक समय में अनुवाद देखने के लिए लाइव अनुवाद भी सक्षम कर सकते हैं।',
  'components.gettingStartedTour.scribeTour.step3.title':
    'रिकॉर्ड बटन पर क्लिक करें, या कोई मौजूदा ऑडियो फ़ाइल अपलोड करें।',
  'components.gettingStartedTour.scribeTour.step4.title':
    'प्रतिलेख सहेजने के लिए तैयार हों तो रोकें पर क्लिक करें।',
  'components.gettingStartedTour.scribeTour.step5.title':
    'अपने प्रतिलेख का नाम लिखें, फिर सहेजें पर क्लिक करें।',
  'components.gettingStartedTour.scribeTour.step6.title':
    'उस बिंदु से ऑडियो चलाने के लिए प्रतिलेख की किसी भी पंक्ति पर क्लिक करें।',
  'components.gettingStartedTour.scribeTour.step7.title':
    'प्रतिलेख में बदलाव करने के लिए संपादित करें पर क्लिक करें।',
  'components.gettingStartedTour.scribeTour.step7.text':
    'आपके बदलाव सुनहरे रंग में दिखाई देते हैं।',
  'components.gettingStartedTour.scribeTour.step8.title':
    'अपने बदलाव रखने के लिए सहेजें पर क्लिक करें।',
  'components.gettingStartedTour.scribeTour.step8.text':
    'सहेजने से पहले आपके संपादन सुनहरे रंग में दिखाई देते हैं।',
  'components.gettingStartedTour.searchTour.completeModal.title': 'बहुत बढ़िया!',
  'components.gettingStartedTour.searchTour.completeModal.description':
    'आपने दस्तावेज़ों में खोज की और प्रासंगिक खंड पाए।',
  'components.gettingStartedTour.searchTour.step1.title':
    'हमने आपके लिए एक खोज क्वेरी तैयार की है।',
  'components.gettingStartedTour.searchTour.step1.text':
    'मेल खाते खंड खोजने के लिए खोजें पर क्लिक करें या Enter दबाएँ।',
  'components.gettingStartedTour.searchTour.step2.title':
    'यह रहा NDA से एक मेल। उसमें सभी मेल देखने के लिए दस्तावेज़ पर क्लिक करें।',
  'components.gettingStartedTour.searchTour.step3.title':
    'दस्तावेज़ के उस अनुभाग पर जाने के लिए किसी भी अंश पर क्लिक करें।',
  'components.gettingStartedTour.searchTour.step3.text':
    'बाईं ओर आपको मेल खाते अंश दिखते हैं। दाईं ओर हाइलाइट किए गए कीवर्ड के साथ पूरा दस्तावेज़ है।',
  'components.gettingStartedTour.tourButton.label': 'टूर',
  'components.gettingStartedTour.tourCompleteModal.features.chat': 'चैट में प्रश्न पूछें',
  'components.gettingStartedTour.tourCompleteModal.features.search': 'दस्तावेज़ों में खोजें',
  'components.gettingStartedTour.tourCompleteModal.features.scribe': 'स्क्राइब से प्रतिलेखन करें',
  'components.gettingStartedTour.tourCompleteModal.features.review': 'समीक्षा से विश्लेषण करें',
  'components.gettingStartedTour.tourCompleteModal.features.playbook':
    'वर्कस्टूडियो में संशोधन लागू करें',
  'components.gettingStartedTour.tourCompleteModal.title': 'आप पूरी तरह तैयार हैं!',
  'components.gettingStartedTour.tourCompleteModal.subtitle':
    'आपने A&GEL टूर पूरा किया और यह करना सीखा:',
  'components.gettingStartedTour.tourCompleteModal.progressText': '5 में से 5 सुविधाएँ पूर्ण',
  'components.gettingStartedTour.tourCompleteModal.ctaButton': 'A&GEL का उपयोग शुरू करें →',
  'components.gettingStartedTour.tourCompleteModal.userGuidePrefix': 'मदद चाहिए? देखें ',
  'components.gettingStartedTour.tourCompleteModal.userGuideLabel': 'उपयोगकर्ता मार्गदर्शिका',
  'components.lLMMetrics.status.fast': 'तेज़',
  'components.lLMMetrics.status.slow': 'धीमा',
  'components.lLMMetrics.status.busy': 'व्यस्त',
  'components.lLMMetrics.status.pending': 'लंबित',
  'components.lLMMetrics.status.loading': 'लोड हो रहा है',
  'components.lLMMetrics.metricBox.defaultChartLabel': 'मान',
  'components.management.passwordModal.usernameColumn': 'उपयोगकर्ता नाम',
  'components.management.passwordModal.passwordColumn': 'पासवर्ड',
  'components.management.passwordModal.createHeader':
    'आपने नीचे दिए गए क्रेडेंशियल के साथ उपयोगकर्ता सफलतापूर्वक बनाया है:',
  'components.management.passwordModal.emailChangeHeader':
    'आपने उपयोगकर्ता का ईमेल सफलतापूर्वक बदल दिया है। नए क्रेडेंशियल नीचे हैं:',
  'components.management.passwordModal.changePasswordNotice':
    '*उपयोगकर्ता को पहली बार लॉग इन करने के बाद अपना पासवर्ड बदलना होगा',
  'components.menuPanel.untitledItem': '(शीर्षकहीन)',
  'components.menuPanel.renameFailed': 'नाम बदलने में विफल',
  'components.menuPanel.deleteConfirm.title': 'इतिहास आइटम हटाएँ',
  'components.menuPanel.deleteConfirm.content':
    'क्या आप वाकई इस इतिहास आइटम को हटाना चाहते हैं? यह कार्रवाई पूर्ववत नहीं की जा सकती।',
  'components.menuPanel.deleteConfirm.createdLabel': 'बनाया गया:',
  'components.menuPanel.deleteSuccess': 'इतिहास आइटम सफलतापूर्वक हटाया गया',
  'components.menuPanel.deleteFailed': 'इतिहास आइटम हटाने में विफल',
  'components.menuPanel.searchHistoryButton': 'इतिहास खोजें',
  'components.menuPanel.historyLabel': 'इतिहास',
  'components.menuPanel.showAllButton': 'सभी दिखाएँ',
  'components.menuPanel.showFavoritesButton': 'पसंदीदा दिखाएँ',
  'components.menuPanel.endOfListMessage': '- यह सूची का अंत है -',
  'components.message.enhanceGpt.modalTitle': 'GPT प्रतिक्रिया बेहतर बनाएँ',
  'components.message.enhanceGpt.successMessage': 'नई प्रतिक्रिया दर्ज की गई',
  'components.message.enhanceGpt.questionLabel': 'प्रश्न: {question}',
  'components.message.enhanceGpt.answerLabel': 'उत्तर',
  'components.message.postback.clickedLabel': 'क्लिक किया गया:',
  'components.message.postback.chatbotButtonFallback': 'चैटबॉट बटन',
  'components.message.locationLabel': 'स्थान',
  'components.message.stickerLabel': 'स्टिकर',
  'components.message.audiosLabel': 'ऑडियो',
  'components.message.imagesLabel': 'छवियाँ',
  'components.message.videosLabel': 'वीडियो',
  'components.msgViewer.fromLabel': 'प्रेषक:',
  'components.msgViewer.toLabel': 'प्राप्तकर्ता:',
  'components.msgViewer.attachmentsLabel': 'अनुलग्नक:',
  'components.pdfViewerWithHighlight.renderError': 'PDF रेंडर करने में विफल',
  'components.promptSelector.copySuccess': 'प्रॉम्प्ट कॉपी हो गया!',
  'components.promptSelector.copyError': 'प्रॉम्प्ट कॉपी करने में विफल',
  'components.promptSelector.noResultsFiltered': 'आपके फ़िल्टर से मेल खाता कोई प्रॉम्प्ट नहीं मिला',
  'components.promptSelector.startTyping': 'प्रॉम्प्ट खोजने के लिए टाइप करना शुरू करें',
  'components.promptSelector.promptLoaded': 'प्रॉम्प्ट लोड हो गया!',
  'components.promptSelector.untitledPrompt': 'शीर्षकहीन प्रॉम्प्ट',
  'components.promptSelector.actionPlaceholder': 'कार्रवाई',
  'components.promptSelector.actionOption.summarise': 'सारांश बनाएँ',
  'components.promptSelector.actionOption.review': 'समीक्षा करें',
  'components.promptSelector.actionOption.amend': 'संशोधित करें',
  'components.promptSelector.actionOption.draft': 'मसौदा तैयार करें',
  'components.promptSelector.actionOption.redFlagging': 'जोखिम चिह्नित करना',
  'components.promptSelector.audiencePlaceholder': 'दर्शक',
  'components.promptSelector.audienceOption.personal': 'व्यक्तिगत',
  'components.promptSelector.audienceOption.group': 'समूह',
  'components.promptSelector.audienceOption.public': 'सार्वजनिक',
  'components.promptSelector.selectPromptHint':
    'इनपुट बॉक्स में लोड करने के लिए कोई प्रॉम्प्ट चुनें',
  'components.promptSelector.usePromptButton': 'प्रॉम्प्ट उपयोग करें',
  'components.promptSelector.authorLabel': 'लेखक',
  'components.promptSelector.promptLabel': 'प्रॉम्प्ट',
  'components.promptSelector.tagsLabel': 'टैग',
  'components.promptSelector.documentsAttached': '{count} दस्तावेज़ संलग्न किए जाएँगे',
  'components.questionListSelection.untitledQuestionList': '(शीर्षकहीन)',
  'components.questionListSelection.questionCount': '{count} प्रश्न',
  'components.questionListSelection.accessPublicTag': 'सार्वजनिक',
  'components.questionListSelection.accessFirmTag': 'फ़र्म',
  'components.questionListSelection.accessGroupTag': 'निजी समूह',
  'components.questionListSelection.viewLess': 'कम देखें',
  'components.questionListSelection.viewAll': 'सभी देखें',
  'components.questionListSelection.whatsNewButton': 'नया क्या है',
  'components.questionListSelection.tourTooltip': 'टूर लें',
  'components.questionListSelection.tourButton': 'टूर',
  'components.questionListSelection.sortMostPopular': 'क्रम: सर्वाधिक लोकप्रिय',
  'components.questionListSelection.sortNameAsc': 'क्रम: नाम A-Z',
  'components.questionListSelection.sortNameDesc': 'क्रम: नाम Z-A',
  'components.questionListSelection.filterByAudiencePlaceholder': 'दर्शक अनुसार फ़िल्टर करें',
  'components.questionListSelection.audienceOptionPersonal': 'व्यक्तिगत',
  'components.questionListSelection.audienceOptionPublic': 'सार्वजनिक',
  'components.questionListSelection.filterByAuthorPlaceholder': 'लेखक अनुसार फ़िल्टर करें',
  'components.reference.unknownAuthor': 'अज्ञात',
  'components.reference.timeAgo.justNow': 'अभी-अभी',
  'components.reference.timeAgo.minutesAgo':
    '{count, plural, one {# मिनट पहले} other {# मिनट पहले}}',
  'components.reference.timeAgo.hoursAgo': '{count, plural, one {# घंटा पहले} other {# घंटे पहले}}',
  'components.reference.timeAgo.daysAgo': '{count, plural, one {# दिन पहले} other {# दिन पहले}}',
  'components.reference.openCellDetails': 'सेल विवरण खोलें',
  'components.reference.answerLabel': 'उत्तर: ',
  'components.reference.explanationLabel': 'स्पष्टीकरण',
  'components.reference.verifiedLabel': 'सत्यापित',
  'components.reference.verifyLabel': 'सत्यापित करें',
  'components.reference.pleaseEnterComment': 'कृपया कोई टिप्पणी दर्ज करें',
  'components.reference.matrixIdRequired':
    'मैट्रिक्स ID आवश्यक है। कृपया सुनिश्चित करें कि Reference कंपोनेंट को matrixId प्रॉप पास किया गया है।',
  'components.reference.commentAddedSuccess': 'टिप्पणी सफलतापूर्वक जोड़ी गई',
  'components.reference.failedToAddComment': 'टिप्पणी जोड़ने में विफल',
  'components.reference.commentUpdatedSuccess': 'टिप्पणी सफलतापूर्वक अपडेट हुई',
  'components.reference.updateOwnCommentsOnly': 'आप केवल अपनी ही टिप्पणियाँ अपडेट कर सकते हैं',
  'components.reference.failedToUpdateComment': 'टिप्पणी अपडेट करने में विफल',
  'components.reference.commentDeletedSuccess': 'टिप्पणी सफलतापूर्वक हटाई गई',
  'components.reference.deleteOwnCommentsOnly': 'आप केवल अपनी ही टिप्पणियाँ हटा सकते हैं',
  'components.reference.failedToDeleteComment': 'टिप्पणी हटाने में विफल',
  'components.reference.deleteComment.title': 'टिप्पणी हटाएँ',
  'components.reference.deleteComment.description': 'क्या आप वाकई इस टिप्पणी को हटाना चाहते हैं?',
  'components.reference.addCommentPlaceholder': 'टिप्पणी जोड़ें...',
  'components.reference.cellsSelected': '{count, plural, one {# सेल चयनित।} other {# सेल चयनित।}}',
  'components.reference.selectCellAriaLabel': 'सेल चुनें',
  'components.reference.selectQuestionRowAriaLabel': 'प्रश्न पंक्ति चुनें',
  'components.reference.selectDocumentColumnAriaLabel': 'दस्तावेज़ कॉलम चुनें',
  'components.reference.selectDocumentRowAriaLabel': 'दस्तावेज़ पंक्ति चुनें',
  'components.reference.selectQuestionColumnAriaLabel': 'प्रश्न कॉलम चुनें',
  'components.reference.documentsHeader': 'दस्तावेज़',
  'components.reference.addRow': 'पंक्ति जोड़ें',
  'components.reference.addColumn': 'कॉलम जोड़ें',
  'components.reference.inverse': 'उलटें',
  'components.reference.showAllColumns': 'सभी कॉलम दिखाएँ',
  'components.reference.showAllRows': 'सभी पंक्तियाँ दिखाएँ',
  'components.reference.resetView': 'दृश्य रीसेट करें',
  'components.reference.summaryView': 'सारांश दृश्य',
  'components.reference.exactQuote': 'शब्दशः उद्धरण',
  'components.reference.exactQuoteView': 'शब्दशः उद्धरण दृश्य',
  'components.reference.detailedView': 'विस्तृत दृश्य',
  'components.reference.exitSelectMode': 'बाहर निकलें',
  'components.reference.chatWithSelectedOutput': 'चयनित आउटपुट के साथ चैट करें',
  'components.reference.selectCells': 'सेल चुनें',
  'components.referencePopover.fileLinkUnavailable': 'फ़ाइल लिंक उपलब्ध नहीं है',
  'components.referencePopover.failedToOpenNewTab': 'नया टैब खोलने में विफल',
  'components.referencePopover.failedToOpenFile': 'फ़ाइल खोलने में विफल',
  'components.referencePopover.openInNewTab': 'दस्तावेज़ नए टैब में खोलें ↗',
  'components.rightContent.organisationSwitcher.switching': 'संगठन बदला जा रहा है...',
  'components.rightContent.organisationSwitcher.switchSuccess': 'संगठन सफलतापूर्वक बदला गया',
  'components.rightContent.organisationSwitcher.switchNoToken': 'संगठन बदलने पर नया टोकन नहीं मिला',
  'components.rightContent.organisationSwitcher.switchError': 'संगठन बदलने में विफल',
  'components.rightContent.organisationSwitcher.unknownOrg': 'अज्ञात संगठन',
  'components.rightContent.organisationSwitcher.defaultLabel': 'संगठन',
  'components.rightContent.organisationSwitcher.tooltipFallback': 'संगठन बदलें',
  'components.rightContent.userGuideButton.label': 'A&GEL Insider',
  'components.rightContent.angelTeamsButton.label': 'संपर्क करें',
  'components.rightContent.reportBug.label': 'बग की रिपोर्ट करें',
  'components.rightContent.reportBug.modalDescription':
    'नीचे दिया गया फ़ॉर्म भरकर बताएँ कि आपको क्या समस्या आई।',
  'components.rightContent.reportBug.contactSectionTitle': 'संपर्क',
  'components.rightContent.reportBug.bugDescriptionSectionTitle': 'बग का विवरण',
  'components.rightContent.reportBug.environmentSectionTitle': 'परिवेश',
  'components.rightContent.reportBug.namePlaceholder': 'अपना नाम दर्ज करें',
  'components.rightContent.reportBug.nameRequired': 'कृपया अपना नाम दर्ज करें',
  'components.rightContent.reportBug.emailLabel': 'ईमेल',
  'components.rightContent.reportBug.emailPlaceholder': 'अपना ईमेल दर्ज करें',
  'components.rightContent.reportBug.emailRequired': 'कृपया अपना ईमेल दर्ज करें',
  'components.rightContent.reportBug.emailInvalid': 'कृपया एक मान्य ईमेल दर्ज करें',
  'components.rightContent.reportBug.locationLabel': 'बग कहाँ मिला?',
  'components.rightContent.reportBug.locationPlaceholder': 'फ़ंक्शन चुनें',
  'components.rightContent.reportBug.locationRequired': 'कृपया बताएँ कि बग कहाँ मिला',
  'components.rightContent.reportBug.descriptionLabel': 'समस्या का विवरण दें',
  'components.rightContent.reportBug.descriptionRequired': 'कृपया समस्या का विवरण दें',
  'components.rightContent.reportBug.filesLabel': 'स्क्रीनशॉट या रिकॉर्डिंग',
  'components.rightContent.reportBug.uploadText': 'अपलोड करने के लिए क्लिक करें या खींचें',
  'components.rightContent.reportBug.fileSizeKb': '{size} KB',
  'components.rightContent.reportBug.removeFile': '{fileName} हटाएँ',
  'components.rightContent.reportBug.deviceLabel': 'डिवाइस',
  'components.rightContent.reportBug.devicePlaceholder': 'MacBook Pro M1 2021',
  'components.rightContent.reportBug.deviceRequired': 'कृपया अपना डिवाइस बताएँ',
  'components.rightContent.reportBug.osLabel': 'ऑपरेटिंग सिस्टम और संस्करण',
  'components.rightContent.reportBug.osPlaceholder': 'macOS Sequoia 15.1',
  'components.rightContent.reportBug.osRequired': 'कृपया अपना OS बताएँ',
  'components.rightContent.reportBug.browserLabel': 'ब्राउज़र',
  'components.rightContent.reportBug.browserPlaceholder': 'ब्राउज़र चुनें',
  'components.rightContent.reportBug.browserRequired': 'कृपया अपना ब्राउज़र बताएँ',
  'components.rightContent.reportBug.submitSuccess': 'बग रिपोर्ट सफलतापूर्वक सबमिट हुई!',
  'components.rightContent.reportBug.submitError':
    'बग रिपोर्ट सबमिट करने में विफल। कृपया पुनः प्रयास करें।',
  'components.rightContent.reportBug.invalidFileType':
    'आप केवल छवि या वीडियो फ़ाइलें ही अपलोड कर सकते हैं!',
  'components.rightContent.reportBug.fileUploadSuccess':
    'फ़ाइल "{fileName}" सफलतापूर्वक अपलोड हुई!',
  'components.rightContent.reportBug.fileUploadError': 'फ़ाइल अपलोड करने में विफल',
  'components.rightContent.reportBug.page.home': 'होम',
  'components.rightContent.reportBug.page.chat': 'चैट',
  'components.rightContent.reportBug.page.composer': 'कंपोज़र',
  'components.rightContent.reportBug.page.review': 'समीक्षा',
  'components.rightContent.reportBug.page.reference': 'संदर्भ',
  'components.rightContent.reportBug.page.files': 'फ़ाइलें',
  'components.rightContent.reportBug.page.userProfile': 'उपयोगकर्ता प्रोफ़ाइल',
  'components.rightContent.reportBug.page.other': 'अन्य',
  'components.rightContent.reportBug.browser.chrome': 'Chrome',
  'components.rightContent.reportBug.browser.safari': 'Safari',
  'components.rightContent.reportBug.browser.firefox': 'Firefox',
  'components.rightContent.reportBug.browser.edge': 'Edge',
  'components.rightContent.reportBug.browser.opera': 'Opera',
  'components.rightContent.reportBug.browser.brave': 'Brave',
  'components.rightContent.reportBug.browser.arc': 'Arc',
  'components.rightContent.reportBug.browser.other': 'अन्य',
  'components.rightContent.receiptModal.title': 'धन्यवाद',
  'components.rightContent.receiptModal.description': 'आपकी रिपोर्ट सबमिट कर दी गई है।',
  'components.scribe.clickToStartRecording': 'रिकॉर्डिंग शुरू करने के लिए क्लिक करें',
  'components.scribe.failedToGetAuthToken': 'प्रमाणीकरण टोकन प्राप्त करने में विफल',
  'components.scribe.failedToStartRecording': 'रिकॉर्डिंग शुरू करने में विफल',
  'components.searchPdfViewerWithHighlight.renderError': 'PDF रेंडर करने में विफल',
  'components.themeToggle.themeSectionLabel': 'थीम',
  'components.themeToggle.themeTeal': '🌊 टील',
  'components.themeToggle.themeMaroon': '🍷 मैरून',
  'components.themeToggle.modeSectionLabel': 'मोड',
  'components.themeToggle.lightMode': 'लाइट',
  'components.themeToggle.darkMode': 'डार्क',
  'components.themeToggle.themeSettingsTooltip': 'थीम सेटिंग्स',
  'components.whatsNewModal.title': 'नया क्या है',
  'components.whatsNewModal.intro':
    'हमने आपकी दस्तावेज़ समीक्षा प्रक्रिया को बेहतर बनाने के लिए कई नई सुविधाएँ जोड़ी हैं:',
  'components.whatsNewModal.feature1.title': 'बेहतर फ़िल्टरिंग: ',
  'components.whatsNewModal.feature1.description':
    'नए दर्शक और लेखक फ़िल्टर, ताकि आप अपनी प्रश्न सूचियाँ तेज़ी से ढूँढ़ सकें।',
  'components.whatsNewModal.feature2.title': 'तात्कालिक प्रश्न: ',
  'components.whatsNewModal.feature2.description': 'चलते-चलते प्रश्न जोड़ने का अधिक लचीला तरीका।',
  'components.whatsNewModal.feature3.title': 'UI सुधार: ',
  'components.whatsNewModal.feature3.description':
    'आपके {featureName} के प्रबंधन के लिए एक स्वच्छ, अधिक सहज इंटरफ़ेस।',
  'components.whatsNewModal.upcomingFeatures.title': 'आगामी सुविधाएँ',
  'components.whatsNewModal.upcomingFeatures.description':
    'सहयोगी समीक्षाओं और उन्नत AI एनालिटिक्स सहित और अपडेट के लिए जुड़े रहें।',
  'components.user.uidLabel': 'UID',
  'components.user.idCopiedMessage': 'ID कॉपी हो गया!',
  'components.file.manager.fetchGroupError': 'समूह लाने में विफल: {message}',
  'components.file.manager.fetchFilesError': 'फ़ाइलें लाने में विफल: {message}',
  'components.file.manager.breadcrumbRoot': 'रूट',
  'components.file.manager.breadcrumbBackUpLevel': 'एक स्तर ऊपर',
  'components.file.manager.searchPlaceholder': 'फ़ाइल या फ़ोल्डर खोजें',
  'components.file.manager.uploadFileButton': 'फ़ाइल अपलोड करें',
  'components.file.manager.createFolderButton': 'फ़ोल्डर बनाएँ',
  'components.file.manager.enterButton': 'खोलें',
  'components.file.manager.deleteFolderButton': 'फ़ोल्डर हटाएँ',
  'components.file.manager.deleteFileButton': 'फ़ाइल हटाएँ',
  'components.file.manager.uploadedByTime': 'अपलोड करने वाला: {username}, अपलोड समय: {createdAt}',
  'components.file.manager.folderNamePlaceholder': 'फ़ोल्डर का नाम',
  'components.file.filePreview.cannotPreview':
    'इस प्रकार की फ़ाइल का पूर्वावलोकन नहीं किया जा सकता',
  'components.file.documentSelector.sortNameAsc': 'नाम (A-Z)',
  'components.file.documentSelector.sortNameDesc': 'नाम (Z-A)',
  'components.file.documentSelector.sortNewestFirst': 'पहले नए',
  'components.file.documentSelector.sortOldestFirst': 'पहले पुराने',
  'components.file.documentSelector.favourites': 'पसंदीदा',
  'components.file.documentSelector.selectedCount': 'चयनित ({count}):',
  'components.file.documentSelector.selectAllFilesInFolder': '{folderName} की सभी फ़ाइलें चुनें',
  'components.file.documentSelector.noFiles': 'कोई फ़ाइल नहीं',
  'components.file.documentSelector.folderAlt': 'फ़ोल्डर',
  'components.file.documentSelector.fileAlt': 'फ़ाइल',
  'components.file.documentSelector.selectDocuments': 'दस्तावेज़ चुनें',
  'components.file.documentSelector.selectOkText': 'चुनें',
  'components.file.fileTree.uploadFailed': '{fileName} अपलोड विफल',
  'components.file.fileTree.clickOrDragToUpload': 'अपलोड करने के लिए क्लिक करें या खींचें',
  'components.file.fileTree.noFilesUploadedOrSelected':
    'अभी तक कोई फ़ाइल अपलोड या चयनित नहीं की गई है।',
  'components.file.selectContext.cannotDeleteDefaultContext':
    'आप डिफ़ॉल्ट संदर्भ नहीं हटा सकते। कृपया पहले किसी अन्य संदर्भ को डिफ़ॉल्ट बनाएँ।',
  'components.file.selectContext.contextDeleted': 'संदर्भ हटाया गया',
  'components.file.selectContext.deleteContextFailed': 'संदर्भ हटाने में विफल',
  'components.file.selectContext.enterContextNameWarning': 'कृपया संदर्भ का नाम दर्ज करें',
  'components.file.selectContext.contextCreated': 'संदर्भ बनाया गया',
  'components.file.selectContext.cannotUnsetDefaultContext':
    'आप डिफ़ॉल्ट संदर्भ को हटा नहीं सकते। कृपया पहले किसी अन्य संदर्भ को डिफ़ॉल्ट बनाएँ।',
  'components.file.selectContext.contextUpdated': 'संदर्भ अपडेट किया गया',
  'components.file.selectContext.createContextFailed': 'संदर्भ बनाने में विफल',
  'components.file.selectContext.updateContextFailed': 'संदर्भ अपडेट करने में विफल',
  'components.file.selectContext.selectContextPresetPlaceholder': 'संदर्भ प्रीसेट चुनें',
  'components.file.selectContext.defaultLabel': '(डिफ़ॉल्ट)',
  'components.file.selectContext.deleteContextConfirmTitle': 'यह संदर्भ हटाएँ?',
  'components.file.selectContext.deleteContextConfirmDescription': 'यह पूर्ववत नहीं किया जा सकता।',
  'components.file.selectContext.addNewContextTooltip': 'नया संदर्भ जोड़ें',
  'components.file.selectContext.modifyContextInfoTooltip': 'संदर्भ जानकारी संशोधित करें',
  'components.file.selectContext.newContextLabel': 'नया संदर्भ',
  'components.file.selectContext.editContextLabel': 'संदर्भ संपादित करें',
  'components.file.selectContext.contextTitlePlaceholder': 'संदर्भ का शीर्षक',
  'components.file.selectContext.setAsDefaultLabel': 'डिफ़ॉल्ट के रूप में सेट करें',
  'components.file.selectContext.contextSelectionTitle': 'संदर्भ चयन',
  'components.file.selectContext.noContextSelected': 'कोई संदर्भ चयनित नहीं',
  'components.appShell.logoutMenuItem': 'लॉग आउट',
  'components.appShell.unauthorized.title': 'यह पृष्ठ आपके लिए नहीं है',
  'components.appShell.unauthorized.backHome': 'होम पर वापस जाएँ',
  'components.appShell.promptLibrary.title': 'प्रॉम्प्ट लाइब्रेरी',
  'components.appShell.promptLibrary.noPromptsAvailable': 'कोई प्रॉम्प्ट उपलब्ध नहीं',
  'components.appShell.promptLibrary.copyTooltip': 'प्रॉम्प्ट सामग्री कॉपी करें',
  'components.appShell.promptLibrary.untitledPrompt': 'शीर्षकहीन प्रॉम्प्ट',
  'components.appShell.promptLibrary.copiedMessage': 'प्रॉम्प्ट क्लिपबोर्ड पर कॉपी हो गया!',
  'components.appShell.clipboard.title': 'क्लिपबोर्ड',
  'components.appShell.clipboard.copiedMessage': 'कॉपी हो गया!',
  'components.appShell.notFound.title': 'यह पृष्ठ मौजूद नहीं है',
  'components.gettingStartedTour.tourTask.chat.title': 'चैट',
  'components.gettingStartedTour.tourTask.chat.duration': '~1 मिनट',
  'components.gettingStartedTour.tourTask.search.title': 'खोज',
  'components.gettingStartedTour.tourTask.search.duration': '~1 मिनट',
  'components.gettingStartedTour.tourTask.scribe.title': 'स्क्राइब',
  'components.gettingStartedTour.tourTask.scribe.duration': '~2 मिनट',
  'components.gettingStartedTour.tourTask.review.title': 'समीक्षा',
  'components.gettingStartedTour.tourTask.review.duration': '~3 मिनट',
  'components.gettingStartedTour.tourTask.playbook.title': 'वर्कस्टूडियो',
  'components.gettingStartedTour.tourTask.playbook.duration': '~2 मिनट',
  'components.matrixPolling.processingStoppedMessage': 'प्रोसेसिंग रोक दी गई',
  'components.matrixPolling.stopProcessingFailedMessage': 'प्रोसेसिंग रोकने में विफल',
  'components.appShell.noResponseError': 'कोई प्रतिक्रिया नहीं! कृपया पुनः प्रयास करें।',
  'components.appShell.requestError': 'अनुरोध में त्रुटि, कृपया पुनः प्रयास करें।',
  'components.appShell.requestFailedError': 'अनुरोध विफल!',
  'components.composerService.socketErrorPrefix': 'त्रुटि: {message}',
  'components.composerService.sessionDisconnected':
    'किसी अन्य कनेक्शन के कारण कंपोज़र सत्र डिस्कनेक्ट हो गया',
  'components.fileViewerWithToken.retrieveFailedError': 'फ़ाइल प्राप्त करने में विफल',
  'components.languageSwitcher.switchLanguageTooltip': 'भाषा बदलें',
  'components.crossOrgBadge.sharedByLabel': 'साझा किया गया: {orgName}',
  'components.crossOrgBadge.externalOrganization': 'बाहरी संगठन',
  'components.file.sharePoint.fromComputer': 'इस कंप्यूटर से',
  'components.file.sharePoint.fromSharePoint': 'SharePoint / OneDrive से',
  'components.file.sharePoint.orAddFromSharePoint': 'या SharePoint / OneDrive से जोड़ें',
  'components.file.sharePoint.account': 'Microsoft खाता',
  'components.file.sharePoint.useDifferentAccount': 'किसी अन्य खाते का उपयोग करें',
  'components.file.sharePoint.disconnect': 'डिस्कनेक्ट करें',
  'components.file.sharePoint.disconnectConfirm':
    'क्या A&GEL से अपना Microsoft खाता डिस्कनेक्ट करना है?',
  'components.file.sharePoint.disconnected': 'Microsoft खाता डिस्कनेक्ट हो गया।',
  'components.file.sharePoint.popupBlocked':
    'SharePoint से फ़ाइलें चुनने के लिए कृपया A&GEL के पॉप-अप की अनुमति दें।',
  'components.file.sharePoint.consentDeniedTitle': 'SharePoint एक्सेस स्वीकृत नहीं हुआ',
  'components.file.sharePoint.consentDenied':
    'SharePoint एक्सेस स्वीकृत नहीं हुआ। यदि आपके संगठन में IT व्यवस्थापक की स्वीकृति आवश्यक है, तो कृपया अपने IT व्यवस्थापक से A&GEL को स्वीकृत करने के लिए कहें।',
  'components.file.sharePoint.copyApprovalLink':
    'अपने IT व्यवस्थापक के लिए स्वीकृति लिंक कॉपी करें',
  'components.file.sharePoint.approvalLinkCopied': 'स्वीकृति लिंक कॉपी हो गया।',
  'components.file.sharePoint.connectFailed':
    'Microsoft से कनेक्ट नहीं हो सका। कृपया पुनः प्रयास करें।',
  'components.file.sharePoint.reconnect': 'कृपया अपना Microsoft खाता फिर से कनेक्ट करें।',
  'components.file.sharePoint.unsupportedType': '{name} यहाँ समर्थित फ़ाइल प्रकार नहीं है।',
  'components.file.sharePoint.tooLarge': '{name} बहुत बड़ी है (अधिकतम {max} MB)।',
  'components.file.sharePoint.rejected': '{name} जोड़ी नहीं जा सकी।',
  'components.file.sharePoint.downloadFailed':
    'SharePoint से {name} प्राप्त नहीं हो सकी। कृपया पुनः प्रयास करें या अपने कंप्यूटर से अपलोड करें।',
  'components.file.sharePoint.folderTooLarge':
    'यह फ़ोल्डर एक बार में आयात करने के लिए बहुत बड़ा है (अधिकतम {max} फ़ाइलें)। कृपया छोटा फ़ोल्डर चुनें।',
  'components.file.sharePoint.chooserTitle': 'फ़ाइलें चुनें',
  'components.file.sharePoint.chooserMyFiles': 'मेरी फ़ाइलें',
  'components.file.sharePoint.chooserShared': 'साझा',
  'components.file.sharePoint.chooserFollowedSites': 'फ़ॉलो की गई साइटें',
  'components.file.sharePoint.chooserSearch': 'साइटें खोजें',
  'components.file.sharePoint.chooserName': 'नाम',
  'components.file.sharePoint.chooserEmpty':
    'आप अभी तक कोई साइट फ़ॉलो नहीं करते। ऊपर किसी साइट को खोजें।',
  'components.file.sharePoint.chooserLocked':
    'केवल वे साइटें दिखाई जाती हैं जिन्हें आप फ़ॉलो करते हैं या खोजते हैं। सभी साइटें ब्राउज़ करने के लिए अपने IT व्यवस्थापक से A&GEL को स्वीकृत करने के लिए कहें।',
  'components.file.sharePoint.chooserLoading': 'लोड हो रहा है…',
  'components.file.sharePoint.chooserSelect': 'चुनें',
  'components.file.sharePoint.chooserCancel': 'रद्द करें',
};
